import { useSensor, useSensors, PointerSensor, SensorDescriptor, SensorOptions } from '@dnd-kit/core';
import { DND_SENSOR_CONFIG } from './DndConstants';

export const useDndSensors = (): SensorDescriptor<SensorOptions>[] => {
  return useSensors(
    useSensor(PointerSensor, {
      activationConstraint: DND_SENSOR_CONFIG.activationConstraint,
    })
  );
};
